import Route from "vue-routisan";
import isAuthenticated from "../middlewares/isAuthenticated";
import isSupplier from "@/http/routes/middlewares/isSupplier";
import hasIntegraPermission from "@/http/routes/middlewares/hasPermission/hasIntegraPermission";

Route.group({}, () => {
  Route.group({prefix: "logistic_manager", beforeEnter: [isAuthenticated, hasIntegraPermission]}, () => {
    Route.group({prefix: "supplier", beforeEnter: [isSupplier]}, () => {
      Route.redirect("/", to => {
        return {name: "supplier.order"};
      });

      Route.group({prefix: "notification"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "supplier" */ "@/resources/views/logistic_manager/supplier/notification/NotificationList.vue")
        ).name("supplier.notification");
      })

      Route.group({ prefix: "order" }, () => {
        Route.group({}, ()=> {
          Route.view("/", () =>
            import(/* webpackChunkName: "supplier" */ "@/resources/views/logistic_manager/supplier/order/OrderList")
          ).name("supplier.order");
          Route.view("/update/:id", () =>
            import(/* webpackChunkName: "supplier" */ "@/resources/views/logistic_manager/supplier/order/OrderUpdate")
          ).name("supplier.order_update");
        });
      });
    });
  });
});

export default Route.all();
